var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:(_vm.value.kariyotei ? 'black--text' : ''),staticStyle:{"display":"inline-block","white-space":"normal","line-height":"1.0rem"}},[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []

export { render, staticRenderFns }